import theme, { gsap, _, $, ScrollTrigger, CSSRulePlugin, ScrollToPlugin} from "./main"


function openFullscreen(elem) {
    if (elem.requestFullscreen) {
        elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) { /* Safari */
        elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE11 */
        elem.msRequestFullscreen();
    }
}

function isFullscreen(){ return 1 >= outerHeight - innerHeight };

theme.on('load', function () {
    console.debug("Theme loading....");
})

theme.on('loaded', function () {
    console.debug("Theme loaded.");

    $('.hero-play-btn').click(() => {
        gsap.to('.app', {
            duration: 0.4,
            scrollTo: '.change'
        })
    })

    $('.hero-scroll-btn').click(() => {
        gsap.to('.app', {
            duration: 0.4,
            scrollTo: '.change'
        })
    })

    $('#trailer-video-play').click(() => {
        $('.trailer-popup').addClass('active');
        openFullscreen($('#trailer-video')[0]);
        $('#trailer-video')[0].pause();
        $('#trailer-video')[0].currentTime = 0;
        $('#trailer-video')[0].load();
        $('#trailer-video')[0].play();

    });
    $('.trailer-popup-close').click(() => {
        $('.trailer-popup').removeClass('active');
        $('#trailer-video')[0].pause();
    })
});